export const ParticipantStatuses = {
    CONSENTED: 'Consented',
};
